module.exports = __webpack_public_path__ + "img/Binance Spot.bc8c9507.png";